/**
 * Which "Action Required" clauses genuinely apply to a member.
 *
 * STARSEED-CAPMARKETS-121. The dashboard banner used to read
 * `registration_paid` / `membership_active` raw, so a founding member
 * whose fees were waived was told to "Complete registration payment"
 * while MembershipCard — taught about waivers by CAPMARKETS-069 —
 * correctly showed "Waived" two panels below. Four live members were in
 * that state at once.
 *
 * The rule: a clause only fires if the member can actually DO something
 * about it. A waived fee is not actionable, so it must not appear.
 */

/**
 * @param {object|null|undefined} user  the auth user object
 * @returns {{registration: boolean, membership: boolean, kyc: boolean, any: boolean}}
 */
export function accountActionRequired(user) {
  const waived = Boolean(user?.fees_waived);

  // A waived registration is settled. Nothing to pay, nothing to prompt.
  const registration = !waived && !user?.registration_paid;

  // Membership activation is likewise implied by the waiver — a founding
  // member whose fees are waived is a member; there is no payment step
  // standing between them and activation.
  const membership = !waived && !user?.membership_active;

  const kyc = user?.kyc_status !== "approved";

  return {
    registration,
    membership,
    kyc,
    any: registration || membership || kyc,
  };
}

export default accountActionRequired;
